var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 19.25H3.33337C2.80294 19.25 2.29423 18.9734 1.91916 18.4812C1.54409 17.9889 1.33337 17.3212 1.33337 16.625V2.625C1.33337 2.39294 1.40361 2.17038 1.52864 2.00628C1.65366 1.84219 1.82323 1.75 2.00004 1.75H11.3334C11.5102 1.75 11.6798 1.84219 11.8048 2.00628C11.9298 2.17038 12 2.39294 12 2.625V13.125H14.6667V16.625C14.6667 17.3212 14.456 17.9889 14.0809 18.4812C13.7058 18.9734 13.1971 19.25 12.6667 19.25ZM12 14.875V16.625C12 16.8571 12.0703 17.0796 12.1953 17.2437C12.3203 17.4078 12.4899 17.5 12.6667 17.5C12.8435 17.5 13.0131 17.4078 13.1381 17.2437C13.2631 17.0796 13.3334 16.8571 13.3334 16.625V14.875H12ZM10.6667 17.5V3.5H2.66671V16.625C2.66671 16.8571 2.73695 17.0796 2.86197 17.2437C2.98699 17.4078 3.15656 17.5 3.33337 17.5H10.6667ZM4.00004 6.125H9.33337V7.875H4.00004V6.125ZM4.00004 9.625H9.33337V11.375H4.00004V9.625ZM4.00004 13.125H7.33337V14.875H4.00004V13.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon1);
export default __webpack_public_path__ + "static/media/dashboard-icon-1.7867574eabdc557e67610877538be6c1.svg";
export { ForwardRef as ReactComponent };